import { createContext, useMemo } from 'react'
import { parseJwt } from '../utilities/common'
import { getAuthorizedMenuItems, menuItems, MenuItem } from '../menu'
import { CustomerData } from '@/actions/userActions'

export const TokenContext = createContext<{
  token: string
  roles: number[]
  username: string
  customers: CustomerData[]
  authorizedMenuItems: MenuItem[]
  authorizedRoutes: string[]
  predefinedRole: string
  roleNames: string[]
  email: string
  team_id: string | number
}>({
  token: '',
  roles: [],
  username: '',
  customers: [],
  authorizedMenuItems: [],
  authorizedRoutes: [],
  predefinedRole: '',
  roleNames: [],
  email: '',
  team_id: ''
})

export const TokenContextProvider = (props: React.PropsWithChildren) => {
  const token = window.localStorage.getItem('auth_token') || ''

  const contextValue = useMemo(() => {
    const contents = token ? parseJwt(token) : {}
    const {
      role_ids: roles = [],
      username = '',
      customer: customers = [],
      email = '',
      ui_abilities: authorizedAbilities = [],
      ui_ability_identifiers: authorizedIdentifiers = [],
      predefined_role,
      role_names = [],
      team_id
    } = contents

    const alwaysVisibleMenuIds =
      import.meta.env.VITE_APP_COUNTRY === 'CA' || predefined_role !== 'super_admin'
        ? []
        : ['metrics-page']

    const authorizedMenuItems = getAuthorizedMenuItems(
      menuItems,
      authorizedAbilities,
      alwaysVisibleMenuIds,
      authorizedIdentifiers
    )

    const getRoutes = (items: MenuItem[]): string[] => {
      return items.reduce((acc: string[], item) => {
        if (item.subitems && item.subitems.length > 0) {
          // 递归处理子项的路由
          acc.push(...getRoutes(item.subitems ?? []))
        }
        acc.push('/' + item.id)
        return acc
      }, [])
    }

    const authorizedRoutes = getRoutes(authorizedMenuItems)

    return {
      token,
      roles,
      username,
      customers,
      email,
      authorizedMenuItems,
      authorizedRoutes,
      predefinedRole: predefined_role,
      roleNames: role_names,
      team_id
    }
  }, [token])

  return (
    <TokenContext.Provider value={contextValue}>
      {props.children}
    </TokenContext.Provider>
  )
}
